<script lang="ts">
  import { isUserLoggedIn, user } from "../app.store";
  import { logout } from "../app.logic";

  import { APP_TITLE } from "../utils/constants";
    import { PortalUserService } from "../services/portal-user.service";
    import { onMount } from "svelte";
    import { formatTimestampHuman } from "../utils/date-utils";
    import { writable } from "svelte/store";

  let appTitle = APP_TITLE;
  let showUserMenu = true;
  let lastUpdate = writable<String>("");
  let lastUpdateOk = writable<boolean>(true);
  $: userFullName = $user != null ? $user.fullName : "";
  $: companyName = $user != null ? $user.regionSettings.companyName : "";

  onMount(async () => {
    let _resp = await PortalUserService.fetchRegionSettings().toPromise();
    for(let i = 0;i<_resp.payload.length;i++)
    {
      let s = _resp.payload[i];
      if (s.key == 'DATA_IMPORT')
      {
          lastUpdate.set(formatTimestampHuman(s.updatedOn));
          lastUpdateOk.set(s.value=="OK");
          break;
      }
    }
  })
  

</script>

<nav class="navbar header-navbar noselect">
  <div class="container content header-content">
    <div class="navbar-brand header-brand">
      <i class="navbar-item">
        <img src="/img/logo.png" alt="Logo" />
      </i>

      <a class="navbar-item brand-text header-brand-text" href="/">
        {appTitle}
      </a>

      <span class="navbar-item brand-text header-brand-text">
        {companyName}
      </span>
    </div>

    <div class="navbar-end">
      {#if $isUserLoggedIn}
        {#if showUserMenu}
        <div>
          <a class="navbar-item header-user-name" href="/profile">
            {userFullName}
          </a> 
          {#if $lastUpdateOk}
            <span class="header-system-status-success">Stato sistema: OK - agg. al: {$lastUpdate}</span>
          {:else}
            <span class="header-system-status-warning">Stato sistema: NON AGGIORNATO- ult. agg.: {$lastUpdate}</span>
          {/if}
        </div>
        {/if}

        <div class="navbar-item">
          <div class="buttons">
            <button class="button is-light" on:click={logout}>
              <strong>Logout</strong>
            </button>
          </div>
        </div>
      {/if}
    </div>
  </div>
</nav>

<style>
  .header-navbar {
    background-color: #ededed;
    border-bottom: 1px solid #d9dee4;
    height: 4rem;
  }

  .header-content {
    max-width: unset !important;
    padding-left: 3rem;
    border-bottom: 1px solid #f2f2f2;
    display: flex !important;
  }

  .header-brand {
    flex: 1;
  }

  .header-brand-text {
    font-weight: 300;
    padding-right: 5rem;
  }

  .header-user-name {
    border: none;    
    margin-bottom: 0rem;
    padding-bottom: 0rem;
    display: block;
    text-align: right;
  }

  
  .header-system-status-success { 
    color: green;
    font-size: 0.8rem;
    display: block;
  }

  
  .header-system-status-warning { 
    color: orange;
    font-size: 0.8rem;
    display: block;
  }

  .header-user-name:hover,
  .header-user-name:focus,
  .header-user-name:focus-within {
    background-color: #ededed;
    outline: none;
  }
</style>
